export const openPopupWindow = (url, name) => {
  const width = 600;
  const height = 700;
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;

  return window.open(
    url,
    name,
    `toolbar=no, location=no, directories=no, status=no, menubar=no, 
    scrollbars=yes, resizable=no, copyhistory=no, 
    width=${width}, height=${height}, 
    top=${top}, left=${left}`
  );
};